import axios from "axios";

// we need to pass the baseURL as an object
const API = axios.create({
  //baseURL: "https://webapi.activekyc.com",
  baseURL: "https://webapi.alrafiq.co.uk",
});

export default API;